export { focus } from './focus'

export const pxToRem = (pxValue: number) => {
  const remValue = pxValue / 16
  return `${remValue}rem`
}

const btoa = typeof window !== 'undefined' ? window.btoa : (str: string) => Buffer.from(str).toString('base64')

export const svgUri = (svgString: string, isEncoded: boolean = false) =>
  `url('data:image/svg+xml;base64, ${isEncoded ? svgString : btoa(svgString)}')`

export const svgColor = (svgString: string, color: string) =>
  svgString.replace(/fill="#?[0-9A-Za-z]*"/g, `fill="${color}"`)

// inspired from https://kovart.github.io/dashed-border-generator/
export const svgDashedBorder = (
  color: string,
  radius: number = 0,
  width: number = 2,
  dashlength: number = 8,
  dashoffset: number = 2,
) => {
  const dasharray = dashlength
  const encodedColor = color.replace('#', '%23')
  return `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='${radius}' ry='${radius}' stroke='${encodedColor}' stroke-width='${width}' stroke-dasharray='${dasharray}' stroke-dashoffset='${dashoffset}'/%3e%3c/svg%3e")`
}

export const visuallyHidden = () => ({
  // visually hidden hack
  height: '1px',
  width: '1px',
  overflow: 'hidden',
  clip: 'rect(1px, 1px, 1px, 1px)',
})

// see https://github.com/takamoso/css-hacks
export const safariOnly = (styles: any, minVersion?: number) => {
  if (minVersion === 14) {
    return {
      '@supports (-webkit-marquee-speed: 0) and (paint-order: fill)': styles,
    }
  }
  return {
    '@media not all and (min-resolution:.001dpcm)': {
      '@supports (-webkit-appearance:none)': styles,
    },
  }
}

// see https://css-tricks.com/snippets/css/css-hacks-targeting-firefox/
export const firefoxOnly = (styles: any) => ({
  '@supports (-moz-appearance:none)': styles,
})

export const arrowGenerator = (size: number, color: string) => ({
  root: {
    "&[data-popper-placement^='top'] > $arrow": {
      bottom: -size / 2,
    },
    "&[data-popper-placement^='bottom'] > $arrow": {
      top: -size / 2,
    },
    "&[data-popper-placement^='left'] > $arrow": {
      right: -size / 2,
    },
    "&[data-popper-placement^='right'] > $arrow": {
      left: -size / 2,
    },
  },
  arrow: {
    position: 'absolute',
    width: size,
    height: size,
    zIndex: -1,
    '&:before': {
      position: 'absolute',
      width: size,
      height: size,
      zIndex: -1,
      content: "''",
      transform: 'rotate(45deg)',
      background: color,
    },
  },
})
